import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "onSubmit"],
    _excluded2 = ["children"],
    _excluded3 = ["children"],
    _excluded4 = ["children"],
    _excluded5 = ["label", "variant", "children", "buttonType"],
    _excluded6 = ["layout", "formWrapperProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import Button from "antd/es/button/index.js";
import Typography from "antd/es/typography/index.js";
import AntForm from "antd/es/form/index.js";
import FormTemplate from '@data-driven-forms/common/form-template';
import { childrenPropTypes } from '@data-driven-forms/common/prop-types-templates';
var Title = Typography.Title,
    Paragraph = Typography.Paragraph;

var Form = function Form(_ref) {
  var children = _ref.children,
      onSubmit = _ref.onSubmit,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(AntForm, _extends({
    onFinish: onSubmit
  }, props), children);
};

Form.propTypes = {
  layout: PropTypes.string,
  onSubmit: PropTypes.func,
  children: childrenPropTypes
};
Form.defaultProps = {
  layout: 'vertical'
};

var Description = function Description(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(Typography, props, /*#__PURE__*/React.createElement(Paragraph, null, children));
};

Description.propTypes = {
  children: childrenPropTypes
};

var TitleComponent = function TitleComponent(_ref3) {
  var children = _ref3.children,
      props = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement(Typography, props, /*#__PURE__*/React.createElement(Title, {
    level: 3
  }, children));
};

TitleComponent.propTypes = {
  children: childrenPropTypes
};

var ButtonGroup = function ButtonGroup(_ref4) {
  var children = _ref4.children,
      props = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }, props), children);
};

ButtonGroup.propTypes = {
  children: childrenPropTypes
};

var ButtonComponent = function ButtonComponent(_ref5) {
  var label = _ref5.label,
      variant = _ref5.variant,
      children = _ref5.children,
      buttonType = _ref5.buttonType,
      props = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    type: "primary",
    htmlType: props.type
  }), label || children);
};

ButtonComponent.propTypes = {
  children: childrenPropTypes,
  label: PropTypes.node,
  variant: PropTypes.string,
  buttonType: PropTypes.string,
  type: PropTypes.string
};

var AntFormTemplate = function AntFormTemplate(_ref6) {
  var layout = _ref6.layout,
      formWrapperProps = _ref6.formWrapperProps,
      props = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/React.createElement(FormTemplate, _extends({
    FormWrapper: Form,
    Button: ButtonComponent,
    ButtonGroup: ButtonGroup,
    Title: TitleComponent,
    Description: Description,
    formWrapperProps: _objectSpread({
      layout: layout
    }, formWrapperProps)
  }, props));
};

AntFormTemplate.propTypes = {
  layout: PropTypes.string,
  formWrapperProps: PropTypes.object
};
export default AntFormTemplate;